import _ from 'underscore'
import Backbone from 'backbone'
import UnlockBannerTemplate from '../templates/unlock-banner.tpl'
import config from '../config'
import { getPriceBySlug } from '../iap'
import Alert from '../helpers/alert'
import user  from '../user'
import messages from '../messages'

const UnlockBannerView = Backbone.View.extend({
    tagName : 'li',
    id: 'title-view',
    className : 'unlock-banner',
    events: {
        'click .unlock': 'unlock'
    },
    price: null,
    initialize () {
        this.template = _.template(UnlockBannerTemplate)
        this.price = getPriceBySlug(config.get('slug'))
    },
    render () {
        this.$el.html(this.template())
        return this
    },
    unlock (event) {
        event.stopPropagation()

        if (user.get('uid') === null) {
            Alert(messages.MSG_NOT_LOGGED_IN)
            Backbone.history.navigate('free-book', { trigger: true })
        } else {
            const slug = config.get('slug')
            Backbone.history.navigate(`app/${slug}/promo-code`, { trigger: true })
        }
    }
});

export default UnlockBannerView;
